import { makeAutoObservable } from "mobx";

export default class BrandModel {
  id;
  name;
  imageUrl;
  logo_image_url;
  image_url;
  slug;
  description;
  metadata;
  user_suggestion;

  constructor(data) {
    this.update(data);

    makeAutoObservable(this);
  }

  update(data) {
    this.id = data._id;
    this.name = data.name;
    this.image_url = data.image_url;
    this.logo_image_url = data.logo_image_url;
    this.slug = data.slug;
    this.description = data.description;
    this.metadata = data.metadata;
    this.user_suggestion = data.user_suggestion;
  }
}
